<template>
  <div>
    <ClientOnly>
      <ProductStoreLocatorLocally v-if="isImperial" :style-id="sku" />
      <ProductStoreLocatorOutra v-else :gtins="sku" />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  sku: string
}>()

const { isImperial } = useCountry()
</script>
